<mat-card class="tickets-card">
  <mat-card-header>
    <mat-card-title>Chamados</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    @if (!isLoading && (!tickets || tickets.length === 0)) {
      <div class="no-tickets">
        Nenhum chamado
      </div>
    }

    @if (!isLoading && tickets && tickets.length > 0) {
      <div class="tickets-list">
        @for (ticket of tickets; track ticket) {
          <app-ticket-summary-tile [ticket]="ticket"></app-ticket-summary-tile>
        }
      </div>
    }
  </mat-card-content>

  @if (!isLoading) {
    <mat-card-actions align="end" class="button-spacing">
      @if (tickets && tickets.length > 0) {
        <button mat-raised-button color="primary"
        (click)="navigateToAllTickets()">Ver todos</button>
      }
      <button mat-raised-button color="accent" (click)="navigateToCreateTicket()">Criar</button>
    </mat-card-actions>
  }

</mat-card>